import type { ApiResponse } from '@shared/types'
import { createService } from 'v2/shared/services/create-service'
import { BackendServiceName } from 'v2/types'
import type {
  HandoffApiKey,
  HandoffConnection,
  HandoffContext,
  RCallHandoffPreview,
} from 'v2/types/api/handoff-context'

// Hodor's workflow routing selects human-specialist; the API key is fetched only when an admin asks.
const client = createService('', true, BackendServiceName.workflow, 'v1')

export const handoffContextService = {
  getCallPreview: (number: string) =>
    client.get<ApiResponse<RCallHandoffPreview>>(
      `/conversations/${encodeURIComponent(number)}/handoff-context-preview`,
    ),
  getContext: (number: string) =>
    client.get<ApiResponse<HandoffContext>>(
      `/conversations/${encodeURIComponent(number)}/handoff-context`,
    ),
  getConnection: () => client.get<ApiResponse<HandoffConnection>>('/handoff-context/connection'),
  revealKey: () => client.post<ApiResponse<HandoffApiKey>>('/handoff-context/connection/key'),
  regenerateKey: () =>
    client.post<ApiResponse<HandoffApiKey>>('/handoff-context/connection/regenerate'),
  renameConnection: (name: string) =>
    client.post<ApiResponse<{ name: string }>>('/handoff-context/connection', { name }),
}
